import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-539d11a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt--20 container content center heightContent"
}
const _hoisted_2 = {
  key: 1,
  class: "offer-card"
}
const _hoisted_3 = { class: "container content offer-card__container" }
const _hoisted_4 = { class: "offer-card__container-title-box" }
const _hoisted_5 = { class: "content__title offer-card__container-title" }
const _hoisted_6 = { class: "offer-card__container-address" }

import { computed, onMounted, onUnmounted, ref, Ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useDevelopersStore } from '@/store/modules/developers';
import { ResidentialComplexCard } from '@/components/Cards';
import { ResidentialComplexType, ResultCardType, SmallCardLSDType } from '@/types';
import { useAppStore } from '@/store/modules/app';
import { errorHandle } from '@/utils/Common/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResidentialComplexPageLayout',
  setup(__props) {

const residentialComplexData: Ref<ResidentialComplexType | undefined> = ref(undefined);
const otherProjects: Ref<SmallCardLSDType[] | undefined> = ref(undefined);
const resultCards: Ref<ResultCardType[] | undefined> = ref(undefined);
const loading = ref(false);
const projectsLoading = ref(false);
const router = useRouter();
const route = useRoute();

const residentialComplexUrl = computed(() => {
  return route.params.url;
});
const updateResidentialComplex = async () => {
  loading.value = true;

  if (residentialComplexUrl.value) {
    try {
      const res = await useDevelopersStore().searchResidentialComplexByUrl(
        residentialComplexUrl.value,
      );

      if (res) {
        residentialComplexData.value = res;

        projectsLoading.value = true;

        try {
          const projects = await useDevelopersStore().searchOtherProjectsByUrlApi(
            residentialComplexUrl.value,
          );

          if (projects) {
            otherProjects.value = projects;
          }

          const offers = await useDevelopersStore().getOffersOfResidentialComplex(
            residentialComplexUrl.value,
          );

          if (offers) {
            resultCards.value = offers;
          }
        } finally {
          projectsLoading.value = false;
        }
      }
    } catch (error) {
      errorHandle(error);
    } finally {
      loading.value = false;
    }
  } else {
    await router.push({ name: 'main' });
  }
};

onMounted(async () => {
  if (useAppStore().getWindowWidth() < 960) {
    document.documentElement.style.setProperty('--btn-up-bottom', '120px');
  }
  await updateResidentialComplex();
});

watch(
  () => residentialComplexUrl.value,
  () => {
    if (residentialComplexUrl.value) {
      updateResidentialComplex();
    }
  },
);
onUnmounted(() => {
  document.documentElement.style.removeProperty('--btn-up-bottom');
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_spinner, {
          size: 50,
          color: "#009D3E"
        })
      ]))
    : (residentialComplexData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(residentialComplexData.value.title), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(residentialComplexData.value.address), 1)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_unref(ResidentialComplexCard), {
                projects: otherProjects.value,
                "projects-loading": projectsLoading.value,
                "residential-complex-data": residentialComplexData.value,
                resultCards: resultCards.value
              }, null, 8, ["projects", "projects-loading", "residential-complex-data", "resultCards"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})